var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.632,
    height: 18.133,
    viewBox: "0 0 15.632 18.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attendance",
    transform: "translate(-56 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M72,225.692H86.381v.938H72Zm6.878-6.741-2.034,1.2.317.539,2.188-1.286a.313.313,0,0,0,.154-.27V216h-.625Z",
    transform: "translate(-15.375 -184.497)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M71.006,28.689H56.625L56,31.464v9.105H71.632V31.464Zm-12.818,2.5a.625.625,0,1,1,.625-.625A.625.625,0,0,1,58.188,31.19Zm5.627,8.441a5,5,0,1,1,5-5A5,5,0,0,1,63.816,39.632ZM68.193,24H59.439v4.064h8.754Zm-5.94,3.126H61V26.5h1.251Zm0-1.563H61v-.625h1.251Zm4.377,1.563H63.19V26.5h3.439Zm0-1.563H63.19v-.625h3.439Z",
    transform: "translate(0)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M144,188.064h.625v.625H144Zm8.128,0h.625v.625h-.625Zm-7.7,2.23.541-.313.313.541-.541.313Zm7.039-4.064.541-.313.313.541-.541.313Zm-5.552,5.781.313-.541.541.313-.313.541Zm4.064-7.039.313-.542.541.313-.313.541Zm-1.917,7.782v-.625h.625v.625Zm0-8.754h.625v.625h-.625Zm1.917,7.782.541-.313.313.542-.541.313Zm-4.064-7.039.541-.313.313.541-.541.313Zm5.552,5.781.313-.541.541.313-.313.541Zm-7.039-4.064.313-.541.541.313-.313.541Z",
    transform: "translate(-84.561 -153.747)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/Attendance.92f935a5f1304c3f9c64084ca2d44742.svg";
export { ForwardRef as ReactComponent };